import { allSupportedExtensions, audioExtensionsToMimeType, imageExtensionsToMimeType, pdfExtensionsToMimeType, videoExtensionsToMimeType, } from '../../constants';
export const isSupportedAudioExtension = (extension) => {
    return audioExtensionsToMimeType.has(extension);
};
export const isSupportedVideoExtension = (extension) => {
    return videoExtensionsToMimeType.has(extension);
};
export const isSupportedImageExtension = (extension) => {
    return imageExtensionsToMimeType.has(extension);
};
export const isPdf = (extension) => {
    return pdfExtensionsToMimeType.has(extension);
};
export const isSupportedExtension = (extension) => {
    return allSupportedExtensions.has(extension);
};
export const getExtensionMimeType = (extension) => {
    const mimeType = allSupportedExtensions.get(extension);
    return mimeType || 'application/octet-stream';
};
